import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authAPI } from '../services/api.ts';
import {
  Alert,
  Anchor,
  Button,
  Center,
  Paper,
  Stack,
  Text,
  TextInput,
  Title,
} from '@mantine/core';

export const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      await authAPI.forgotPassword(email);
      setSuccess(true);
    } catch (err: any) {
      setError(err.message || 'Failed to process request');
    } finally {
      setIsLoading(false);
    }
  };

  if (success) {
    return (
      <Center mih="100vh" p="md">
        <Paper withBorder shadow="md" p="xl" w="100%" maw={420}>
          <Stack gap="lg">
            <Stack gap={4}>
              <Title order={3} ta="center">
                Check Your Email
              </Title>
              <Text size="sm" c="dimmed" ta="center">
                If an account exists for {email}, you will receive password
                reset instructions.
              </Text>
            </Stack>
            <Button component={Link} to="/login" fullWidth>
              Return to Login
            </Button>
          </Stack>
        </Paper>
      </Center>
    );
  }

  return (
    <Center mih="100vh" p="md">
      <Paper withBorder shadow="md" p="xl" w="100%" maw={420}>
        <Stack gap={4} mb="lg">
          <Title order={2} ta="center">
            Forgot Password
          </Title>
          <Text size="sm" c="dimmed" ta="center">
            Enter your email address and we'll send you a link to reset your
            password.
          </Text>
        </Stack>

        <form onSubmit={handleSubmit}>
          <Stack gap="md">
            {error && (
              <Alert color="red" variant="light">
                {error}
              </Alert>
            )}

            <TextInput
              id="email"
              type="email"
              label="Email address"
              required
              withAsterisk={false}
              value={email}
              onChange={(e) => setEmail(e.currentTarget.value)}
            />

            <Button type="submit" fullWidth loading={isLoading}>
              Send Reset Link
            </Button>

            <Anchor component={Link} to="/login" size="sm" fw={500} ta="center">
              Back to Login
            </Anchor>
          </Stack>
        </form>
      </Paper>
    </Center>
  );
};
